/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });

  document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('iframe-modal');
  const frame = document.getElementById('iframe-modal-frame');
  const closeBtn = modal.querySelector('.iframe-modal__close');

  // Intercept menu clicks
  document.querySelectorAll('a[data-iframe]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      frame.src = link.dataset.iframe;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    modal.classList.remove('is-active');
    frame.src = '';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });
});

/*for menu iframe*/
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href^="#iframe="]');
  if (!link) return;

  e.preventDefault();

  const modal = document.getElementById('iframe-modal');
  const frame = document.getElementById('iframe-modal-frame');

  if (!modal || !frame) {
    console.error('Iframe modal elements not found');
    return;
  }

  const src = link.getAttribute('href').replace('#iframe=', '');
  console.log('Opening iframe:', src);

  frame.src = src;
  modal.classList.add('is-active');
  document.body.style.overflow = 'hidden';
});

// Close logic
document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('iframe-modal') ||
    e.target.classList.contains('iframe-modal__close')
  ) {
    const modal = document.getElementById('iframe-modal');
    const frame = document.getElementById('iframe-modal-frame');

    modal.classList.remove('is-active');
    frame.src = '';
    document.body.style.overflow = '';
    history.replaceState(null, '', window.location.pathname);
  }
});

})();
